import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

import "react-datepicker/dist/react-datepicker.css"
import "./assets/scrollbar.css"

// Locale
import 'moment/locale/pt-br'

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <App />
);